import * as React from "react";
import { useState } from "react";

interface ProjectData {
  corporateId:string;
  name: string;
  contactName: string;
  contactWhatsappNumber: string;
  contactPhoneNumber: string;
  contactEmail: string;
}

interface CreateProjectPopupProps {
  onClose: () => void;
  onCreateProject: (projectData: ProjectData) => void;
  corporateId:string;
  error:string;
}

const CreateProjectPopup: React.FC<CreateProjectPopupProps> = ({ onClose, onCreateProject,corporateId,error }) => {
  const [formData, setFormData] = useState<ProjectData>({
    corporateId:"",
    name: '',
    contactName: '',
    contactWhatsappNumber: '',
    contactPhoneNumber: '',
    contactEmail: ''
  })
  
  const [errors, setErrors] = useState({
    name: '',
    contactName: '',
    contactWhatsappNumber: '',
    contactPhoneNumber: '',
    contactEmail: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    
    // Prevent non-digit input for phone fields
    if ((name === 'contactWhatsappNumber' || name === 'contactPhoneNumber') && value && !/^\d*$/.test(value)) {
      return;
    }
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (errors[name as keyof typeof errors]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
    name: '',
    contactName: '',
    contactWhatsappNumber: '',
    contactPhoneNumber: '',
    contactEmail: ''
    };

    // Project Name validation
    if (!formData.name.trim()) {
      newErrors.name = 'Project name is required';
      valid = false;
    } else if (formData.name.trim().length < 3) {
      newErrors.name = 'Project name must be at least 3 characters';
      valid = false;
    } else if (formData.name.trim().length > 100) {
      newErrors.name = 'Project name cannot exceed 100 characters';
      valid = false;
    }

    // Contact Name validation
    if (!formData.contactName.trim()) {
      newErrors.contactName = 'Contact name is required';
      valid = false;
    } else if (formData.contactName.trim().length < 2) {
      newErrors.contactName = 'Contact name must be at least 2 characters';
      valid = false;
    } else if (formData.contactName.trim().length > 50) {
      newErrors.contactName = 'Contact name cannot exceed 50 characters';
      valid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(formData.contactName.trim())) {
      newErrors.contactName = 'Contact name can only contain letters and spaces';
      valid = false;
    }

    // Mobile validation
    if (!formData.contactPhoneNumber.trim()) {
      newErrors.contactPhoneNumber = 'Mobile number is required';
      valid = false;
    } else if (!/^\d+$/.test(formData.contactPhoneNumber)) {
      newErrors.contactPhoneNumber = 'Mobile number must contain only digits';
      valid = false;
    } else if (formData.contactPhoneNumber.length < 9) {
      newErrors.contactPhoneNumber = 'Mobile number must be at least 9 digits';
      valid = false;
    } else if (formData.contactPhoneNumber.length > 15) {
      newErrors.contactPhoneNumber = 'Mobile number cannot exceed 15 digits';
      valid = false;
    }

    // WhatsApp validation
    if (!formData.contactWhatsappNumber.trim()) {
      newErrors.contactWhatsappNumber = 'WhatsApp number is required';
      valid = false;
    } else if (!/^\d+$/.test(formData.contactWhatsappNumber)) {
      newErrors.contactWhatsappNumber = 'WhatsApp number must contain only digits';
      valid = false;
    } else if (formData.contactWhatsappNumber.length < 9) {
      newErrors.contactWhatsappNumber = 'WhatsApp number must be at least 9 digits';
      valid = false;
    } else if (formData.contactWhatsappNumber.length > 15) {
      newErrors.contactWhatsappNumber = 'WhatsApp number cannot exceed 15 digits';
      valid = false;
    }

    // Email validation
    if (!formData.contactEmail.trim()) {
      newErrors.contactEmail = 'Email is required';
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.contactEmail)) {
      newErrors.contactEmail = 'Invalid email format';
      valid = false;
    } else if (formData.contactEmail.length > 100) {
      newErrors.contactEmail = 'Email cannot exceed 100 characters';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {

      onCreateProject({...formData,corporateId:corporateId});
      onClose();
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(50, 64, 84, 0.4)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      fontFamily: "'Poppins', sans-serif",
    }}>
      <div style={{
        backgroundColor: '#FFFFFF',
        padding: '32px',
        width: '703px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
      }}>

        {/* Header with title and close button */}
        <div style={{
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.1)",
          padding: "20px 24px",
          color: "rgba(60, 66, 87, 1)",
          fontSize: 16,
          fontFamily: "'Poppins', sans-serif",
          height: 69,
          fontWeight: 600,
          margin: "-31px -31px 10px -31px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <h2 style={{
            fontSize: '20px',
            fontWeight: 600,
            color: '#324054',
            fontFamily: "'Poppins', sans-serif",
            margin: 0,
          }}>
            CREATE PROJECTS
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "38px",
              color: "#324054",
              padding: "0",
              display: "flex",
              alignItems: "center"
            }}
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {error&&error.length>0 && <div style={{
            backgroundColor: '#EF9A9A' ,
            padding: '8px',
            borderRadius: '4px',
            marginBottom: '12px',
           }}><span style={{
              color: '#171111ff',
              fontSize: '12px',
              marginTop: '4px',
              display: 'block',
            }}>{error}</span>
          </div>}
          {/* Project Name Field */}
          <div>
            <label style={{
              display: 'block',
              textAlign: 'left',
              fontSize: '16px',
              fontWeight: 500,
              color: '#324054',
              marginBottom: '8px',
            }}>
              Project Name <span style={{ color: '#EF4444' }}>*</span>
            </label>
            <input
              style={{
                width: '100%',
                padding: '10px 12px',
                border: `1px solid ${errors.name ? '#EF4444' : '#E5E7EB'}`,
                borderRadius: '4px',
                fontSize: '16px',
                fontWeight: 500,
                outline: 'none',
                fontFamily: "'Poppins', sans-serif",
                boxSizing: 'border-box',
                color: '#324054',
              }}
              type="text"
              name="name"
              placeholder="Enter project name here"
              value={formData.name}
              onChange={handleChange}
              maxLength={100}
            />
            {errors.name && <span style={{
              color: '#EF4444',
              fontSize: '12px',
              marginTop: '4px',
              display: 'block',
            }}>{errors.name}</span>}
          </div>
          
          {/* Contact Name and Mobile in same row */}
          <div style={{ display: 'flex', gap: '16px' }}>
            {/* Contact Name */}
            <div style={{ flex: 1 }}>
              <label style={{
                display: 'block',
                textAlign: 'left',
                fontSize: '16px',
                fontWeight: 500,
                color: '#324054',
                marginBottom: '8px',
              }}>
                Contact Name <span style={{ color: '#EF4444' }}>*</span>
              </label>
              <input
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: `1px solid ${errors.contactName ? '#EF4444' : '#E5E7EB'}`,
                  borderRadius: '4px',
                  fontSize: '16px',
                  fontWeight: 500,
                  outline: 'none',
                  fontFamily: "'Poppins', sans-serif",
                  boxSizing: 'border-box',
                  color: '#324054',
                }}
                type="text"
                name="contactName"
                placeholder="Enter contact name here"
                value={formData.contactName}
                onChange={handleChange}
                maxLength={50}
              />
              {errors.contactName && <span style={{
                color: '#EF4444',
                fontSize: '12px',
                marginTop: '4px',
                display: 'block',
              }}>{errors.contactName}</span>}
            </div>
            
            {/* Mobile */}
            <div style={{ flex: 1 }}>
              <label style={{
                display: 'block',
                textAlign: 'left',
                fontSize: '16px',
                fontWeight: 500,
                color: '#324054',
                marginBottom: '8px',
              }}>
                Mobile <span style={{ color: '#EF4444' }}>*</span>
              </label>
              <input
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: `1px solid ${errors.contactPhoneNumber ? '#EF4444' : '#E5E7EB'}`,
                  borderRadius: '4px',
                  fontSize: '16px',
                  fontWeight: 500,
                  outline: 'none',
                  fontFamily: "'Poppins', sans-serif",
                  boxSizing: 'border-box',
                  color: '#324054',
                }}
                type="tel"
                name="contactPhoneNumber"
                placeholder="eg - 07x xx xx xxx"
                value={formData.contactPhoneNumber}
                onChange={handleChange}
                pattern="[0-9]*"
                inputMode="numeric"
                maxLength={15}
              />
              {errors.contactPhoneNumber && <span style={{
                color: '#EF4444',
                fontSize: '12px',
                marginTop: '4px',
                display: 'block',
              }}>{errors.contactPhoneNumber}</span>}
            </div>
          </div>
          
          {/* Email and WhatsApp in same row */}
          <div style={{ display: 'flex', gap: '16px' }}>
            {/* Email */}
            <div style={{ flex: 1 }}>
              <label style={{
                display: 'block',
                textAlign: 'left',
                fontSize: '16px',
                fontWeight: 500,
                color: '#324054',
                marginBottom: '8px',
              }}>
                Email <span style={{ color: '#EF4444' }}>*</span>
              </label>
              <input
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: `1px solid ${errors.contactEmail ? '#EF4444' : '#E5E7EB'}`,
                  borderRadius: '4px',
                  fontSize: '16px',
                  fontWeight: 500,
                  outline: 'none',
                  fontFamily: "'Poppins', sans-serif",
                  boxSizing: 'border-box',
                  color: '#324054',
                }}
                type="email"
                name="contactEmail"
                placeholder="example@gmail.com"
                value={formData.contactEmail}
                onChange={handleChange}
                maxLength={100}
              />
              {errors.contactEmail && <span style={{
                color: '#EF4444',
                fontSize: '12px',
                marginTop: '4px',
                display: 'block',
              }}>{errors.contactEmail}</span>}
            </div>
            
            {/* WhatsApp */}
            <div style={{ flex: 1 }}>
              <label style={{
                display: 'block',
                textAlign: 'left',
                fontSize: '16px',
                fontWeight: 500,
                color: '#324054',
                marginBottom: '8px',
              }}>
                WhatsApp <span style={{ color: '#EF4444' }}>*</span>
              </label>
              <input
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: `1px solid ${errors.contactWhatsappNumber ? '#EF4444' : '#E5E7EB'}`,
                  borderRadius: '4px',
                  fontSize: '16px',
                  fontWeight: 500,
                  outline: 'none',
                  fontFamily: "'Poppins', sans-serif",
                  boxSizing: 'border-box',
                  color: '#324054',
                }}
                type="tel"
                name="contactWhatsappNumber"
                placeholder="eg - 07x xx xx xxx"
                value={formData.contactWhatsappNumber}
                onChange={handleChange}
                pattern="[0-9]*"
                inputMode="numeric"
                maxLength={15}
              />
              {errors.contactWhatsappNumber && <span style={{
                color: '#EF4444',
                fontSize: '12px',
                marginTop: '4px',
                display: 'block',
              }}>{errors.contactWhatsappNumber}</span>}
            </div>
          </div>
          
          {/* Action Buttons */}
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '12px',
            marginTop: '16px',
            paddingTop: '16px',
            position: 'sticky',
            bottom: 0,
            backgroundColor: '#FFFFFF',
            paddingBottom: '8px',
          }}>
            <button
              type="button"
              style={{
                padding: '8px 16px',
                borderRadius: '4px',
                fontWeight: 500,
                fontSize: '14px',
                cursor: 'pointer',
                minWidth: '120px',
                fontFamily: "'Poppins', sans-serif",
                backgroundColor: '#FFFFFF',
                color: '#324054',
                border: '1px solid #324054',
              }}
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                padding: '8px 16px',
                borderRadius: '4px',
                fontWeight: 500,
                fontSize: '14px',
                cursor: 'pointer',
                minWidth: '120px',
                fontFamily: "'Poppins', sans-serif",
                backgroundColor: '#2563EB',
                color: '#FFFFFF',
                border: 'none',
              }}
            >
              Create Project
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateProjectPopup;